export { default as capitalizeFirstLetterOfString } from './capitalize-first-letter-of-string';
